import { Raffle } from '@/app/entities/Raffle'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { Button } from '@/view/components/ui/button'
import { Progress } from '@/view/components/ui/progress'
import { Info, Ticket } from 'lucide-react'
import { useState } from 'react'
import CouponModal from './CouponModal'
import { useAuth } from '@/app/hooks/useAuth'

interface RaffleCouponsProps {
  raffle: Raffle
}

const RaffleCoupons = ({ raffle }: RaffleCouponsProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { isAdmin } = useAuth()

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  return (
    <div className="flex w-full flex-col gap-5 rounded-2xl border p-5">
      <div className="flex w-full items-center justify-between">
        <h2 className="text-2xl font-semibold text-primary">Cupons válidos</h2>
        <h2 className="text-4xl font-semibold">{raffle.couponsCount}</h2>
      </div>
      <div className="flex w-full flex-col gap-4">
        <Progress
          value={(raffle?.couponProgress / raffle?.couponValue) * 100}
        />
        <div className="flex w-full items-center justify-between text-muted-foreground">
          <div className="flex items-center gap-2">
            <Info size={20} />
            <span className="font-semibold">Próximo cupom</span>
          </div>
          <div className="font-semibold">
            <span className="text-primary">
              {formatMoneyValue(raffle?.couponProgress ?? 0)}
            </span>{' '}
            / {formatMoneyValue(raffle?.couponValue ?? 0)}
          </div>
        </div>

        {!isAdmin && (
          <Button
            className="w-full rounded-full border border-gray-300 bg-gray-100 text-black hover:bg-gray-200"
            onClick={handleOpenModal}
          >
            <Ticket strokeWidth={1} className="mr-2" /> Ver meus cupons
          </Button>
        )}
      </div>

      <CouponModal
        raffleTitle={raffle.name}
        raffleDescription={raffle.description}
        raffleBanner={raffle.banner}
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        raffleId={raffle?._id}
      />
    </div>
  )
}

export default RaffleCoupons
